import { Link } from "react-router";
import styles from "./Page.module.css";

export function PrivacyPage() {
  return (
    <article className={styles.page}>
      <h1 className={styles.title}>Privacy policy</h1>
      <p className={styles.muted}>Last updated November 3, 2026</p>
      <p>
        This is a personal, private time-tracking deployment at clockify.bopes.party. It is not affiliated with Clockify
        or CAKE.com, and it is not offered to the public.
      </p>
      <h2 className={styles.subtitle}>What is stored</h2>
      <p>
        Your name, email address and profile picture from your sign-in provider, plus the time entries, projects and
        other records you create. Data is stored in Cloudflare (Workers and D1) and is used only to run this app.
      </p>
      <h2 className={styles.subtitle}>Google sign-in</h2>
      <p>
        Google sign-in is used only for authentication. The app requests your basic profile and email address to
        identify your account. It does not read your Gmail, Drive, Calendar or contacts.
      </p>
      <h2 className={styles.subtitle}>Sharing</h2>
      <p>
        No data is sold, rented or shared with advertisers. There are no analytics or tracking scripts. Data is
        disclosed only if the law requires it.
      </p>
      <h2 className={styles.subtitle}>Deletion</h2>
      <p>Ask the operator of this deployment to delete your account and all associated data at any time.</p>
      <nav className={styles.footer}>
        <Link to="/">Home</Link>
        <Link to="/terms">Terms</Link>
      </nav>
    </article>
  );
}
